<script setup lang="ts">
import { MMText } from '@mm-frontend/mm-web-ui-kit';

interface Props {
  title: string;
  count?: number;
  slug: string;
  active?: boolean;
}

interface Emits {
  (e: 'click', slug: string): void;
}

const props = withDefaults(defineProps<Props>(), {
  count: 0,
  active: false,
});

const emit = defineEmits<Emits>();

const onClick = () => {
  emit('click', props.slug);
};
</script>

<template>
  <MMText
    font="Body L/Medium Long"
    :class="{ 'product-tab': true, 'product-tab_active': active }"
    @click="onClick()"
  >
    {{ title }}
    <span class="product-tab__counter" v-if="count">{{ count }}</span>
  </MMText>
</template>

<style scoped lang="stylus">
.product-tab
  background #F2F4F7
  color #8B8E99
  text-align center
  display flex
  min-width 72px
  height 40px
  justify-content center
  align-items center
  cursor pointer
  padding 0 16px
  border-radius 20px
  transition all .3s ease

  &:hover
    background #E6E8ED
    color #8B8E99

  &.product-tab_active
    background #1F2026
    color #FFFFFF

.product-tab__counter
  margin-left 6px
  color #8B8E99
</style>
